
import { ProductData, ProfileProductsResponse } from '../types/productTypes';
import { fetchProfileName } from './profileService';
import { fetchVideosFromSupabase, fetchVideoById } from './videoService';

// Function to fetch products for one or more profiles
export const fetchProductsForProfiles = async (profileIds: string[]): Promise<ProfileProductsResponse> => {
  try {
    if (profileIds.length === 0) {
      return { products: [], profileName: undefined };
    }

    // Use the first profile to get the profile name (used in the UI)
    const profileName = await fetchProfileName(profileIds[0]);
    
    // Fetch all videos from the selected profiles
    let allProducts: ProductData[] = [];
    
    // For each profile ID, fetch videos and combine them
    for (const profileId of profileIds) {
      const profileVideos = await fetchVideosFromSupabase(profileId);
      allProducts = [...allProducts, ...profileVideos];
    }
    
    return {
      products: allProducts,
      profileName
    };
  } catch (error) {
    console.error('Error fetching products for profiles:', error);
    return { products: [], profileName: undefined };
  }
};

// Helper function to get a product by ID
export const getProductById = async (productId: string): Promise<ProductData | null> => {
  try {
    return await fetchVideoById(productId);
  } catch (error) {
    console.error(`Error fetching product with id ${productId}:`, error);
    return null;
  }
};

export { fetchProfileName, fetchVideosFromSupabase, fetchVideoById };
